import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description:
      'Edit one of the beneficial owners and grant them access to the account',
    title: 'The legal representative of the account is missing',
  },
  fr: {
    description:
      'Éditez un•e des bénéficiaires effectifs et accordez-lui l’accès au compte',
    title: 'La•le représentant•e légal•e du compte est manquant•e',
  },
});
